import { ButtonStylesSettings } from './ButtonStyles';

const Button = ({ text, iconSize = '16px', iconRight, iconLeft, buttonStyle, disabled, onClick, className = '' }) => {
    const style = ButtonStylesSettings[buttonStyle] || ButtonStylesSettings.PrimarySolid;
    const IconLeft = iconLeft;
    const IconRight = iconRight;

    const calcBordersStyle = () => {
        let borderStr = '';
        if (style.border) {
            borderStr = `border border-${style.border}`;
        }

        if (style.borderHover) {
            borderStr += ` hover:border-${style.borderHover}`;
        }

        if (style.borderFocus) {
            borderStr += ` focus:border-${style.borderFocus} focus:ring-${style.borderFocus}`;
        }

        return borderStr;
    };

    const calcButtonStyle = () => {
        let styleStr = `${calcBordersStyle()} bg-${style.background} hover:bg-${style.backgroundHover}  text-${
            style.color
        }`;

        if (disabled) {
            styleStr = `bg-${style.backgroundDisabled} text-${style.colorDisabled}
                 ${style.borderDisabled ? `border border-${style.borderDisabled}` : ''}`;
        }

        return styleStr;
    };

    return (
        <button
            onClick={disabled ? () => {} : onClick}
            className={`select-none font-sf transition ease-out duration-300 flex items-center rounded-lg text-13 ${
                text ? 'h-8 w-fit py-2 px-3 justify-between' : 'h-6 w-6 justify-center'
            } ${iconLeft && text ? 'pl-2' : ''} ${iconRight && text ? 'pr-2' : ''} ${
                disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            } font-medium ${calcButtonStyle()} ${className}`}>
            {IconLeft && (
                <IconLeft
                    style={{ width: iconSize, height: iconSize }}
                    fill={disabled ? style.iconColorDisabled : style.iconColor}
                />
            )}
            {text && <span className="mx-1">{text}</span>}
            {IconRight && (
                <IconRight
                    style={{ width: iconSize, height: iconSize }}
                    fill={disabled ? style.iconColorDisabled : style.iconColor}
                />
            )}
        </button>
    );
};

export default Button;
